import { IAxiosResponseData } from '@/store';
import { axios } from '@/nmb/request';

const api = `api/Mysoft.Calendar.Common.AppServices.TaskCenterProxyAppService/`;

// 【任务中心-移动端】获取任务详情
export const CenterGetTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}MobileTaskCenterGetTask`, params);

// 【任务中心-移动端】接收任务
export const CenterReceiveTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}MobileTaskCenterReceiveTask`, params);

// 【任务中心-移动端】-拒绝任务
export const CenterRejectTask = async (params: any): Promise<IAxiosResponseData> => await axios.post(`${api}MobileTaskCenterRejectTask`, params);
